import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SessionStorageCheckInterceptor } from './sessionStorageCheck.interceptor';
import { ChannelApplicationInterceptor } from './channelApplication.interceptor';
import { UndefinedUrlInterceptor } from '@coreModule/interceptors/undefined-url-interceptor';
import { TokenInterceptorService } from './token-interceptor.service';
import { LobInterceptor } from '@coreModule/interceptors/lob.interceptor';
import { SessionIdInterceptor } from './sessionId.interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: ChannelApplicationInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: SessionStorageCheckInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: UndefinedUrlInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LobInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: SessionIdInterceptor, multi: true }
];
